<template>
  <div>
    <!-- todo 需要数据验证 -->
    <van-nav-bar
      class="backBox"
      title="取消课程消息"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="content_box">
      <div class="message_box">
        <div class="create-time">
          <div class="msgBeforeTit">上报时间：</div>
          <div class="msgAfterText">{{ createTime }}</div>
        </div>

        <div class="content-wrap">
          <div class="content-title msgBeforeTit">消息内容：</div>
          <span class="msgAfterText">{{ content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'

export default {
  data () {
    return {
      createTime: '',
      content: '',
      detailObj: {},

      id: null,

      images: [],
      reply_time: '',
      result: '',
      comment: '',
      roomName: '',
      haddleOption: [
        { value: 1, name: '未解决', checked: 'true' },
        { value: 2, name: '已解决' },
        { value: 3, name: '不解决' }
      ]

    }
  },
  mounted () {
    this.detailObj = this.$route.query
    this.queryList()
  },
  computed: {

  },
  methods: {
    queryList () {
      const para = {
        id: this.detailObj.id
      }
      api
        .axiosRequest(api.urlList.cancelBookAdmin, para)
        .then((res) => {
          let createTime = ''
          if (res.code === common.resCode.OK) {
            createTime = utils.formatDate(res.create_time)

            // 赋值
            this.createTime = utils.formatZHYMDHM(createTime)
            this.content = res.content

            this.readMag()
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    readMag () {
      const para = {
        announcement_id: this.detailObj.id
      }
      api
        .axiosRequest(api.urlList.readMsg, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {

          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    onClickLeft () {
      this.$router.go(-1)
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  .message_box {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0.625rem 0.9375rem;
    background-color: #fff;
    color: #666;

    .create-time {
      display: flex;
      align-items: center;
      font-size: 1rem;
      color: #666;
    }
    .content-wrap {
      margin-top: 0.625rem;
      display: flex;
    }

    .content-title {
      white-space: nowrap;
      font-size: 1rem;
      color: #666;
    }

    .content-txt {
      font-weight: 300;
      font-size: 1rem;
    }
  }
}
</style>
